import { apiCall } from '../../utils/restclient'
import {
  GET_PAST_VISIT_INFO,
  GET_PAST_VISIT_INFO_ERROR,
  GET_PAST_VISIT_INFO_SUCCESS,
  GET_PAST_VISIT_PRESCRIPTION,
  GET_PAST_VISIT_PRESCRIPTION_ERROR,
  GET_PAST_VISIT_PRESCRIPTION_SUCCESS,
  GET_PROVIDER_INFO_VISIT_INFO,
  GET_PROVIDER_INFO_VISIT_INFO_ERROR,
  GET_PROVIDER_INFO_VISIT_INFO_SUCCESS,
} from './PastVisitConstants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getVisitInfo = (visitId) => {
  const endpoint = `api/v1/visits/${visitId}`
  const action = {
    type: GET_PAST_VISIT_INFO,
    extraData: { visitId },
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_PAST_VISIT_INFO_SUCCESS,
      error: GET_PAST_VISIT_INFO_ERROR,
      extraData: { visitId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getPastVisitPrescriptionInfo = (visitId) => {
  const endpoint = `api/v1/visits/${visitId}/prescriptions`
  const action = {
    type: GET_PAST_VISIT_PRESCRIPTION,
    extraData: { visitId },
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_PAST_VISIT_PRESCRIPTION_SUCCESS,
      error: GET_PAST_VISIT_PRESCRIPTION_ERROR,
      extraData: { visitId },
    })
    return action
  } catch (e) {
    console.log(e)
  }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export function getProviderInfo(providerId, visitId) {
  const endpoint = `api/v1/providers/${providerId}`
  const extraData = { providerId, visitId }
  const action = {
    type: GET_PROVIDER_INFO_VISIT_INFO,
    extraData,
  }
  try {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    apiCall(endpoint, 'GET', null, null, {
      success: GET_PROVIDER_INFO_VISIT_INFO_SUCCESS,
      error: GET_PROVIDER_INFO_VISIT_INFO_ERROR,
      extraData,
    })
    return action
  } catch (e) {
    console.log(e)
  }
}
